<template>
  <div id="status-contratos-toolbar">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Estatus de Contratos
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ToolBarStatusContratos',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
